import { render, staticRenderFns } from "./Attendance.vue?vue&type=template&id=c2ff971c&scoped=true"
import script from "./Attendance.vue?vue&type=script&lang=js"
export * from "./Attendance.vue?vue&type=script&lang=js"
import style0 from "./Attendance.vue?vue&type=style&index=0&id=c2ff971c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ff971c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2ff971c')) {
      api.createRecord('c2ff971c', component.options)
    } else {
      api.reload('c2ff971c', component.options)
    }
    module.hot.accept("./Attendance.vue?vue&type=template&id=c2ff971c&scoped=true", function () {
      api.rerender('c2ff971c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/partials/Menus/Attendance.vue"
export default component.exports